import React from 'react';

import { Route, Routes } from 'react-router-dom';
import ChangePassword from '../components/ChangePassword';
import AddCustomer from '../../../Screens/Customers/AddCustomer';
import CustomerList from '../../../Screens/Customers/CustomerList';
import UpdateCustomer from '../../../Screens/Customers/UpdateCustomer';
import ViewCustomer from '../../../Screens/Customers/ViewCustomer';
import ServiceForms from '../../../Screens/Booking/ServiceForm';
import PassengerDetails from '../../../Screens/Booking/PassengerDetails';
import BookingSummary from '../../../Screens/Booking/BookingSummary';
import ProfileUpdate from '../components/ProfileUpdate';
import AdminReports from '../../../Screens/Reports/AdminReports';
import BookingList from '../../../Screens/Booking/BookingsList';
import ViewBooking from '../../../Screens/Booking/ViewBooking';
import EditBooking from '../../../Screens/Booking/EditBooking';
import Payments from '../../../Screens/Payment/ViewPaymentList';
import ViewPayment from '../../../Screens/Payment/ViewPayment';
import VendorDashBoard from '../components/VendorDashBoard';
import SuccessPage from '../../../Screens/Booking/SuccessPage';

import {
  VENDOR_ADD_CUSTOMER,
  VENDOR_BOOKING_AIRPORT_DETAILS,
  VENDOR_BOOKING_PASSENGER_DETAILS,
  VENDOR_BOOKING_SUMMARY,
  VENDOR_BOOKINGS,
  VENDOR_CHANGE_PASSWORD,
  VENDOR_CUSTOMERS,
  VENDOR_DASHBOARD,
  VENDOR_EDIT_BOOKINGS,
  VENDOR_EDIT_CUSTOMER,
  VENDOR_PROFILE_UPDATE,
  VENDOR_REPORTS,
  VENDOR_VIEW_BOOKINGS,
  VENDOR_VIEW_CUSTOMER,
  VENDOR_SUCCESS_PAGE,
  VENDOR_INVOICES,
  VENDOR_VIEW_INVOICE,
} from './VendorRoutes';
import {
  PAYMENT_CANCLED,
  PAYMENT_FAILURE,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS,
} from './AppRoutes';
import PaymentProcessingPage from '../../../Screens/Payment/PaymentProcessingPage';
import PaymentFailure from '../../../Screens/Payment/PaymentFailure';
import PaymentSuccess from '../../../Screens/Payment/PaymentSuccess';
import PaymentCancellation from '../../../Screens/Payment/PaymentCancle';

const AuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path={VENDOR_DASHBOARD} element={<VendorDashBoard />} />

      <Route path={VENDOR_CUSTOMERS} element={<CustomerList />} />
      <Route path={VENDOR_ADD_CUSTOMER} element={<AddCustomer />} />
      <Route path={VENDOR_EDIT_CUSTOMER} element={<UpdateCustomer />} />
      <Route path={VENDOR_VIEW_CUSTOMER} element={<ViewCustomer />} />

      <Route path={VENDOR_CHANGE_PASSWORD} element={<ChangePassword />} />
      <Route path={VENDOR_PROFILE_UPDATE} element={<ProfileUpdate />} />
      <Route path={VENDOR_REPORTS} element={<AdminReports />} />
      <Route path={VENDOR_BOOKING_AIRPORT_DETAILS} element={<ServiceForms />} />
      <Route path={VENDOR_BOOKING_SUMMARY} element={<BookingSummary />} />
      <Route
        path={VENDOR_BOOKING_PASSENGER_DETAILS}
        element={<PassengerDetails />}
      />
      <Route path={VENDOR_BOOKINGS} element={<BookingList />} />
      <Route path={VENDOR_VIEW_BOOKINGS} element={<ViewBooking />} />
      <Route path={VENDOR_EDIT_BOOKINGS} element={<EditBooking />} />

      <Route path={VENDOR_INVOICES} element={<Payments />} />
      <Route path={VENDOR_VIEW_INVOICE} element={<ViewPayment />} />
      <Route path={VENDOR_SUCCESS_PAGE} element={<SuccessPage />} />
      <Route path={PAYMENT_SUCCESS} element={<PaymentSuccess />} />
      <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />

      <Route path={PAYMENT_PROCESSING} element={<PaymentProcessingPage />} />
      <Route path={PAYMENT_CANCLED} element={<PaymentCancellation />} />
    </Routes>
  );
};
export default AuthenticatedRoutes;
